(function ($) {
    $(document).ready(function () {

    $('input[type=password]').each(function () {
        var $passwordInput = $(this);

        (function () {
            var $selfPasswordInput = $passwordInput;
            var $wrapper = $('<div style="position:relative;"></div>');
            var $showButton = $('<button type="button" title="Show password" class="show-password-toggle" tabindex="-1"></button>');
            $showButton.click(function () {

                if ($selfPasswordInput.prop('type') == 'password') {
                    $selfPasswordInput.prop('type', 'text');
                    $showButton.prop('title', 'Hide password');
                    $showButton.addClass('password-visible');
                }
                else {
                    $selfPasswordInput.prop('type', 'password');
                    $showButton.prop('title', 'Show password');
                    $showButton.removeClass('password-visible');
                }
            });
          
            $selfPasswordInput.on('input', function () { $showButton.show(); });
            $selfPasswordInput.wrap($wrapper);
            $showButton.insertAfter($selfPasswordInput);
        })();
    });
});
})(jQuery);